export default "__VITE_ASSET__Pzujyfsn__"